import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MenuItem, Select, Typography } from 'seagull';
import { defaultWidth } from './constants';
const isTrueValue = (value)=>value === 'true' || value === true;
const compareValues = (value1, value2)=>isTrueValue(value1) === isTrueValue(value2);
export function CoverCreditCardFeesSelector(props) {
    const { value, className, vendorBusinessName, clientBusinessName, testId, width = defaultWidth, disabled, onChange, onOpen } = props;
    const valueToText = useMemo(()=>({
            true: vendorBusinessName || 'The service provider',
            false: clientBusinessName || 'The client'
        }), [
        clientBusinessName,
        vendorBusinessName
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: "Define who will pay the credit card processing fee"
            }),
            /*#__PURE__*/ _jsx(Select, {
                collapseHelperText: false,
                style: {
                    marginBlockStart: 8
                },
                value: value,
                displayValue: valueToText[value.toString()],
                isSelected: (itemValue, currentValue)=>compareValues(currentValue, itemValue),
                testId: testId && "".concat(testId, "-dropdown"),
                width: width,
                disabled: disabled,
                onChange: (e)=>onChange(isTrueValue(e.target.value)),
                onClick: onOpen,
                children: [
                    'false',
                    'true'
                ].map((value, idx)=>/*#__PURE__*/ _jsx(MenuItem, {
                        value: value,
                        testId: testId && "".concat(testId, "-option-").concat(idx),
                        children: valueToText[value]
                    }, value))
            })
        ]
    });
}
